import { GrfqQuote } from '#/unified-rfqs/entities/grfq/domain';
import createSafeContext from '@paradigm/utils/createSafeContext';

export interface AggGrfqQuote extends GrfqQuote {
  numQuotes: number;
}

export const [useMyAggBids, MyAggBidsProvider] =
  createSafeContext<AggGrfqQuote[]>('MyAggBids');
export const [useMyAggAsks, MyAggAsksProvider] =
  createSafeContext<AggGrfqQuote[]>('MyAggAsks');

export const [useAggBid, AggBidProvider] = createSafeContext<
  AggGrfqQuote | undefined
>('AggBid');
export const [useAggAsk, AggAskProvider] = createSafeContext<
  AggGrfqQuote | undefined
>('AggAsk');
